import { permissions, ProjectTag } from 'model';
import { useTranslation } from 'react-i18next';
import { useHistory, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { Delete as DeleteIcon, Edit as EditIcon } from '@material-ui/icons';
import {
  GenericTable,
  useCreateCells
} from '../../../../components/table/GenericTable';
import { ApiState } from '../../../auth/redux/types';
import { entityColumnBuilder } from '../../../../components/table/columns.builder';
import { useAppDispatch } from '../../../../redux/redux.hooks';
import { projectTagThunk } from '../../redux/project-tag.thunk';

function buildTableColumns() {
  return entityColumnBuilder<ProjectTag>()
    .addDefaultColumn('tag_name', 'name', 'Name')
    .addDefaultColumn('tag_description', 'description', 'Description').columns;
}

interface ProjectTagTableProps {
  projectTags: ProjectTag[];
  onRefresh: () => void;
  apiState: ApiState;
}

export function ProjectTagTable({
  projectTags,
  onRefresh,
  apiState
}: ProjectTagTableProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { url } = useRouteMatch();
  const history = useHistory();
  const tableCells = useCreateCells(buildTableColumns(), []);
  const deleteProjectTag = (id: string) => {
    dispatch(projectTagThunk.delete({ id }));
  };
  return (
    <GenericTable
      label={t('Project Tags')}
      refresh={onRefresh}
      primaryButton={{
        label: 'New Project Tag',
        onClick: () => history.push(`${url}?type=create#project-tag`),
        permission: permissions.project.projectTag.create
      }}
      data={projectTags}
      isLoading={apiState === 'pending'}
      tableCells={tableCells}
      rowActions={[
        {
          permissions: permissions.project.projectTag.edit,
          entry: (step) => ({
            icon: EditIcon,
            label: 'Edit',
            link: `${url}?type=edit#${step.id}`
          })
        },
        {
          permissions: permissions.project.projectTag.delete,
          entry: (sc) => ({
            icon: DeleteIcon,
            label: 'Delete',
            alert: {
              title: 'Delete Project Tag',
              content: `${t(
                'You may only delete a project tag ' +
                  'if it is not referenced anymore. ' +
                  'Otherwise an error will occur. ' +
                  'Are you sure you want to delete project tag '
              )} "${sc.name}"?`,
              onConfirm: () => {
                deleteProjectTag(sc.id);
              }
            }
          })
        }
      ]}
      toolbarActions={[]}
    />
  );
}
